import { RootState } from 'store';

import { STATE } from '../types/state';

import { INotice } from '../types/notice';

const selector = (state: RootState): INotice[] | null => {
  const { notice } = state[STATE];
  return notice;
};

export default selector;
